// extracted by mini-css-extract-plugin
export default {"root":"StoreLocationTextCard_root__zW0ge","title":"StoreLocationTextCard_title__B1v1j","areaText":"StoreLocationTextCard_areaText__RE5Ma"};